/** Mirrors the relay README error contract: JSON {error:{reason,message,fields?}}. */
export interface RelayFieldError {
  path: string;
  rule: string;
  message: string;
}

export class RelayError extends Error {
  constructor(
    readonly status: number,
    readonly reason: string,
    message: string,
    readonly fields?: RelayFieldError[],
  ) {
    super(`relay ${status} ${reason}: ${message}`);
    this.name = "RelayError";
  }

  /** Build from a non-2xx Response; tolerant of plain-text 404/405 bodies. */
  static async from(res: Response): Promise<RelayError> {
    const text = await res.text();
    try {
      const j = JSON.parse(text) as { error?: { reason?: string; message?: string; fields?: RelayFieldError[] } };
      const e = j?.error ?? {};
      return new RelayError(res.status, e.reason ?? "unknown", e.message ?? text, e.fields);
    } catch {
      return new RelayError(res.status, "non-json", text || res.statusText);
    }
  }
}

/** FH-5 / spec 3 §3.2: the relay answered 409 — the requested fromSeq (or resume
 *  cursor) is below the ephemeral purge floor and the gap is unrecoverable. Carries
 *  the new floor so the caller can re-seed (seedable types) or clamp to it. */
export class BackfillResetError extends RelayError {
  constructor(readonly firstSeq: number) {
    super(409, "reset", `backfill below purge floor; firstSeq=${firstSeq}`);
    this.name = "BackfillResetError";
  }
}
